import { freeze } from '@reduxjs/toolkit';
import { appRoutes, ISidebarLink } from '../../../path';
import { PermissionKey } from '../../../utils/apollo/graphqlSchema';

export const scheduleNavLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'Dashboard',
      url: appRoutes.schedules.dashboard,
      tooltip: {
        content: 'View and manage Dashboard schedules',
      },
      permissionKeys: [PermissionKey.DashboardScheduleRead],
    },
    {
      title: 'Report',
      url: appRoutes.schedules.report,
      tooltip: {
        content: `View and manage Report schedules`,
      },
      permissionKeys: [PermissionKey.AnalysisScheduleRead],
    },
  ],
  true,
);
